import { useParams, Link } from 'react-router-dom';
import { CustomerDetailRouteParams } from './customer-detail-tab';
import { Card, Col, Row } from 'antd';
import { ReadRentsQuery, useRents } from '../rents/useRents';
import { FormattedDate } from 'react-intl';
import { getStateString, getPayedRentTag } from '../rents/Table';
import { RentResponse } from '../../../api/client/data-contracts';
import { IconProps } from 'react-iconly';
import { FC } from 'react';
import { Icon, MoneyRecive, WalletMoney } from 'iconsax-react';

function calculateTotalValue(rents: RentResponse[]) {
  return Number(
    rents
      .filter((rent) => rent.state !== 'ORDERING' && rent.payed)
      .reduce((prev, curr) => prev + curr.paymentTotalWithVat, 0)
      .toFixed(2),
  );
}

function calculateTotalCustomerDebt(rents: RentResponse[]) {
  return Number(
    rents
      .filter((rent) => rent.state !== 'ORDERING' && !rent.payed)

      .reduce((prev, curr) => prev + curr.paymentTotalWithVat, 0)
      .toFixed(2),
  );
}

export const PrettyCard: FC<{
  Icon: FC<IconProps> | Icon;
  value: number;
  unit: string;
  label: string;
  color?: 'warning' | 'primary' | 'danger' | 'success';
}> = ({ value, Icon, unit, label, color = 'primary' }) => {
  return (
    <Card className='hp-border-color-black-40'>
      <Row>
        <Col
          className={`hp-statistic-icon-bg hp-mr-16 hp-mb-xs-16 hp-bg-color-${color}-4 hp-bg-color-dark-${color}`}
        >
          <Icon
            className={`hp-text-color-${color}-1 hp-text-color-dark-${color}-2 remix-icon`}
          />
        </Col>

        <Col className='hp-mt-8'>
          <h3 className='hp-mb-4'>
            {value}
            <span
              className={`hp-badge-text hp-ml-8 hp-text-color-${color}-1 hp-text-color-dark-${color}-2`}
            >
              {unit}
            </span>
          </h3>

          <p
            className={`hp-p1-body hp-mb-0 hp-text-color-${color}-80 hp-text-color-${color}-30`}
          >
            {label}
          </p>
        </Col>
      </Row>
    </Card>
  );
};

const CustomerRentsTab = () => {
  const { id } = useParams<CustomerDetailRouteParams>();

  const { rentsQuery: currentCustomerRents, openRent } = useRents({
    customer: id,
  } as unknown as ReadRentsQuery);

  const totalPaymentValue = calculateTotalValue(
    currentCustomerRents.data || [],
  );
  const totalDebt = calculateTotalCustomerDebt(currentCustomerRents.data || []);
  const unit = '€';
  return (
    <Row gutter={16}>
      <Col span='16'>
        {currentCustomerRents.data && (
          <Row gutter={[12, 12]}>
            {currentCustomerRents.data.map((rent, index) => (
              <Col
                key={index}
                span={24}
                className='hp-bg-black-0 hp-bg-dark-100 hp-border-radius-xxl hp-border-1 hp-border-color-black-10 hp-border-color-dark-80 hp-p-12'
                onClick={() => openRent(rent.id)}
              >
                <Link to={''}>
                  <Row align='middle' justify='space-between'>
                    <Col sm={8} span={24} className='hp-mb-sm-16'>
                      <Row align='middle' wrap={false}>
                        <Col>
                          {rent.code && (
                            <span className='hp-d-block h4'>{rent.code}</span>
                          )}

                          <span className='hp-d-block hp-p1-body hp-mt-4'>
                            {rent.customer.description}
                          </span>
                        </Col>
                      </Row>
                    </Col>

                    <Col
                      sm={6}
                      span={12}
                      className='hp-text-sm-left hp-text-right'
                      style={{ minHeight: 50 }}
                    >
                      <span className='hp-d-block h4 hp-font-weight-400'>
                        <FormattedDate value={rent.startDate} />
                      </span>

                      <span className='hp-d-block hp-p1-body hp-mr-4 hp-mt-4'>
                        <FormattedDate value={rent.endDate} />
                      </span>
                    </Col>
                    <Col
                      span={12}
                      sm={4}
                      className='hp-text-right hp-mr-4'
                      style={{ minHeight: 50 }}
                    >
                      {getStateString(rent.state)}

                      <span className='hp-d-block hp-p1-body hp-mt-4'>
                        {getPayedRentTag(rent.payed)}
                      </span>
                    </Col>
                  </Row>
                </Link>
              </Col>
            ))}
          </Row>
        )}
      </Col>
      <Col>
        <PrettyCard
          label={'Valor total pago'}
          Icon={WalletMoney}
          value={totalPaymentValue}
          unit={unit}
        />
        <PrettyCard
          label={'Valor total por pagar'}
          Icon={MoneyRecive}
          value={totalDebt}
          unit={unit}
        />
      </Col>
    </Row>
  );
};

export default CustomerRentsTab;
